(function () {
  if (window.__shareCartImportInitialized) return;
  window.__shareCartImportInitialized = true;

  function getRootUrl() {
    const root = window.Shopify?.routes?.root || '/';

    return root.endsWith('/') ? root : root + '/';
  }

  function removeLoadingState() {
    document.documentElement.classList.remove(
      'share-cart-import-pending',
      'share-cart-import-is-loading'
    );
  }

  function parseSharedItems(value) {
    if (!value) return [];

    return value
      .split(',')
      .map(function (item) {
        const parts = item.split(':');
        const id = Number(parts[0]);
        const quantity = Number(parts[1]);

        if (
          !Number.isSafeInteger(id) ||
          !Number.isInteger(quantity) ||
          id <= 0 ||
          quantity <= 0
        ) {
          return null;
        }

        return {
          id: id,
          quantity: quantity
        };
      })
      .filter(Boolean);
  }

  async function readResponse(response) {
    const data = await response.json().catch(function () {
      return {};
    });

    if (!response.ok) {
      throw new Error(
        data.description ||
        data.message ||
        'No fue posible cargar el carrito compartido.'
      );
    }

    return data;
  }

  async function importSharedCart() {
    const currentUrl = new URL(window.location.href);
    const sharedValue = currentUrl.searchParams.get(
      'share_cart'
    );

    if (!sharedValue) {
      removeLoadingState();
      return;
    }

    const items = parseSharedItems(sharedValue);

    if (!items.length) {
      console.error(
        '[Compartir carrito] El enlace no contiene productos válidos.'
      );

      removeLoadingState();
      return;
    }

    const rootUrl = getRootUrl();

    const cleanCartUrl = new URL(
      rootUrl + 'cart',
      window.location.origin
    );

    document.documentElement.classList.add(
      'share-cart-import-is-loading'
    );

    try {
      const clearResponse = await fetch(
        rootUrl + 'cart/clear.js',
        {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({})
        }
      );

      await readResponse(clearResponse);

      const addResponse = await fetch(
        rootUrl + 'cart/add.js',
        {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: items
          })
        }
      );

      await readResponse(addResponse);

      /*
       * Confirmamos que Shopify ya guardó los productos
       * antes de navegar a la página limpia del carrito.
       */
      const cartResponse = await fetch(
        rootUrl + 'cart.js',
        {
          method: 'GET',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json'
          },
          cache: 'no-store'
        }
      );

      const cart = await readResponse(cartResponse);

      if (!cart.items || cart.items.length === 0) {
        throw new Error(
          'Shopify no pudo reconstruir el carrito.'
        );
      }

      /*
       * sessionStorage evita volver a ejecutar la importación
       * durante la recarga limpia.
       */
      sessionStorage.setItem(
        'share-cart-imported',
        'true'
      );

      window.location.replace(
        cleanCartUrl.toString()
      );
    } catch (error) {
      console.error(
        '[Compartir carrito]',
        error
      );

      removeLoadingState();

      alert(
        error.message ||
        'No fue posible cargar el carrito compartido.'
      );
    }
  }

  function init() {
    const currentUrl = new URL(window.location.href);
    const hasSharedCart = currentUrl.searchParams.has(
      'share_cart'
    );

    if (!hasSharedCart) {
      removeLoadingState();
      sessionStorage.removeItem(
        'share-cart-imported'
      );
      return;
    }

    importSharedCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      { once: true }
    );
  } else {
    init();
  }
})();